import { useCallback, useEffect, useState } from 'react';

const useStageSize = () => {
  const [containerNode, setContainerNode] = useState(null);
  const [size, setSize] = useState({ width: 0, height: 0 });

  const containerRef = useCallback((node) => {
    setContainerNode(node);
  }, []);

  useEffect(() => {
    if (!containerNode) {
      setSize({ width: 0, height: 0 });
      return undefined;
    }

    const updateSize = () => {
      setSize({
        width: Math.max(0, containerNode.clientWidth),
        height: Math.max(0, containerNode.clientHeight),
      });
    };

    updateSize();

    const observer = new ResizeObserver(updateSize);
    observer.observe(containerNode);

    return () => observer.disconnect();
  }, [containerNode]);

  return { containerRef, size };
};

export default useStageSize;
